import axios from 'axios';
import setAuthToken from '../utils/setAuthToken'
import jwt_decode from 'jwt-decode';
import { SET_STUDENT, SET_ERRORS_HELPER} from '../actionTypes'

let apiUrl = "http://localhost:5000";

if (process.env.REACT_APP_VERCEL_API) {
    apiUrl = `${process.env.REACT_APP_VERCEL_API}`;
}

const setStudent = (data) => {
    return {
        type: SET_STUDENT,
        payload: data
    }
}

const getAllSubjectsHelper = (data) => {
    return {
        type: "GET_ALL_SUBJECTS",
        payload: data
    }
}
const studentNoticeBoardHelper = (data) => {
    return {
        type: "GET_ALL_NOTICE",
        payload: data
    }
}
const studentTimeTableHelper = (data) => {
    return {
        type: "GET_ALL_TIMETABLE",
        payload: data
    }
}

const studentAssignmentsHelper = (data) => {
    return {
        type: "GET_ALL_ASSIGNMENTS",
        payload: data
    }
}


const fetchAttendenceHelper = (data) => {
    return {
        type: "GET_ATTENDENCE",
        payload: data
    }
}

const getMarksHelper = (data) => {
    return {
        type: "GET_MARKS",
        payload: data
    }
    
}

export const studentLogin = (studentCredential) => {
    return async (dispatch) => {
        try {
            const { data } = await axios({
                method: 'Post',
                url: apiUrl  + "/api/student/login",
                data: studentCredential
            })
            const { token } = data;
            // Set token to local Storage
            localStorage.setItem('studentJwtToken', token);
            // Set token to Auth header
            setAuthToken(token);
            // Decode token to get user data
            const decoded = jwt_decode(token);
            // Set current user
            dispatch(setStudent(decoded))
           
        }
        catch (err) {
            dispatch({
                type: SET_ERRORS_HELPER,
                payload: err.response.data
            })
        }
    }
}

export const studentUpdatePassword = (passwordData) => {
    return async (dispatch) => {
        try {
            console.log(passwordData)
            const { data } = await axios({
                method: 'Post',
                url: apiUrl  + "/api/student/updatePassword",
                data: passwordData
            })
            alert("Password Updated Successfully")
           
        }
        catch (err) {
            dispatch({
                type: SET_ERRORS_HELPER,
                payload: err.response.data
            })
        }
    }
}


export const getAllSubjects = () => {
    return async (dispatch) => {
        try {
            const { data } = await axios({
                method: 'Get',
                url: apiUrl  + "/api/student/getAllSubjects"
            })
            dispatch(getAllSubjectsHelper(data.result))
        }
        catch (err) {
            console.log("Error in sending message", err.message)
        }
    }
}
export const studentNoticeBoard = () => {
    return async (dispatch) => {
        try {
            const { data } = await axios({
                method: 'Get',
                url: apiUrl  + "/api/student/studentNoticeBoard"
            })
            dispatch(studentNoticeBoardHelper(data))
        }
        catch (err) {
            console.log("Error in sending message", err.message)
        }
    }
}
export const studentTimeTable = () => {
    return async (dispatch) => {
        try {
            const { data } = await axios({
                method: 'Get',
                url: apiUrl  + "/api/student/studentTimeTable",
            })
            dispatch(studentTimeTableHelper(data))
        }
        catch (err) {
            console.log("Error in sending message", err.message)
        }
    }
}

export const fetchStudentAssignments = () => {
    return async (dispatch) => {
        try {
            const { data } = await axios({
                method: 'Get',
                url: apiUrl  + "/api/student/studentAssignments",
            })
            dispatch(studentAssignmentsHelper(data))
        }
        catch (err) {
            console.log("Error in sending message", err.message)
        }
    }
}
export const studentAssignmentSubmit = (studentAssignmentSubmitData) => {
    return async (dispatch) => {
        console.log(studentAssignmentSubmitData)
        try {
            const { data } = await axios({
                method: 'Post',
                url: apiUrl  + "/api/student/studentAssignmentSubmit",
                data:studentAssignmentSubmitData
                
            })
            alert('Assignment submitted successfully');

        }
        catch (error) {
            if (error.response && error.response.status === 400 && error.response.data.message.includes('Duplicate link')) {
                alert('Duplicate link. Please submit a different link.');
            } else {
                console.error('Error in sending message:', error.message);
            }
        }
    }
}
export const fetchAttendence = () => {
    return async (dispatch) => {
        try {
            const { data } = await axios({
                method: 'Get',
                url: apiUrl  + "/api/student/checkAttendence"
            })
            dispatch(fetchAttendenceHelper(data.result))
        }
        catch (err) {
            console.log("Error in sending message", err.message)
        }
    
    }
}

export const getMarks = () => {
    return async (dispatch) => {
        try {
            const { data } = await axios({
                method: 'Get',
                url: apiUrl  + "/api/student/getMarks"
            })
           dispatch(getMarksHelper(data.result))
        }
        catch (err) {
            console.log("Error in getting marks", err.message)
        }
    }
}



export const setStudentUser = data => {
    return {
        type: SET_STUDENT,
        payload: data
    };
}

export const studentLogout = () =>
    (dispatch) => {
        // Remove token from localStorage
        localStorage.removeItem('studentJwtToken');
        // Remove auth header for future requests
        setAuthToken(false);
        // Set current user to {} which will set isAuthenticated to false
        dispatch(setStudent({}));
    };